import styled from '@emotion/styled';

const TrackArtistName = styled('div')(({ theme }) => ({
  color: theme.colors.gray.medium,
}));

export default TrackArtistName;
